import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,CanLoad } from '@angular/router';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/shared-components/shared.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate,CanLoad {
    constructor(private readonly router: Router, private readonly sharedService: SharedService) { }

    canActivate(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.isLoginApplication()) {
            return true;
        } else {
            return false;
        }
    }

    canLoad(): Observable<boolean> | Promise<boolean> | boolean {
        
        if (this.isDocApplication()) {
            const result = JSON.parse(this.sharedService.getLocalStorage('ssaAppConfig'));
            if (result && result['OTP'] === 'VALID') {
                return true;
            } else if (sessionStorage.getItem('cpuserData') !== null) {
                
                return true;
            } else if (result || result['OTP'] !== 'VALID') {
                this.router.navigate(['/login']);
                return false;
            }
            else {
                this.sharedService.showError('App Details is not found');
                this.router.navigate(['/error']);
                return false;
            }
        } else {
            this.sharedService.showError('App Details is not found');
            this.router.navigate(['/error']);
            return false;
        }
    }

    private isDocApplication() {
        if ((localStorage.getItem('ssaAppConfig') !== null && localStorage.getItem('ssaAppConfig') !== undefined) ||
            sessionStorage.getItem('cpuserData') !== null && sessionStorage.getItem('cpuserData') !== undefined) {
            return true;
        } else {
            return false;
        }
    }

    isLoginApplication() {
        if (this.isDocApplication()) {
            const result = JSON.parse(this.sharedService.getLocalStorage('ssaAppConfig'));
            if (result && result['OTP'] === 'VALID') {
                this.router.navigate(['/cplead/leads']);
                return true;
            } else if (sessionStorage.getItem('cpuserData') !== null) {
                this.router.navigate(['/cplead/leads']);
                return true;
            } else if (result || result['OTP'] !== 'VALID') {
                return true;
            }
            else {
                this.sharedService.showError(this.sharedService.getErrors().default, 'error');
                this.router.navigate(['/error']);
                return false;
            }
        } else {
            this.sharedService.showError('Some keys are not found');
            this.router.navigate(['/error']);
            return false;
        }
    }
}
